import { reactive } from '@/utils/reactive' // Assuming you might have a utility, but I will write a simple vanilla implementation here to be safe and dependency-free.

export type UploadStatus = 'preparing' | 'uploading' | 'processing' | 'complete' | 'error'

export interface UploadItem {
  id: string
  fileName: string
  progress: number // 0 to 100
  status: UploadStatus
  message?: string
  jobId?: string // Linked Firestore Job ID
}

class UploadStore {
  private items: UploadItem[] = []
  private listeners: ((items: UploadItem[]) => void)[] = []

  // Add a new file to the queue
  addItem(fileName: string): string {
    const id = Math.random().toString(36).substring(7)
    this.items.push({
      id,
      fileName,
      progress: 0,
      status: 'preparing',
      message: 'Initializing...'
    })
    this.notify()
    return id
  }

  // Update an existing item
  updateItem(id: string, updates: Partial<UploadItem>) {
    const index = this.items.findIndex(i => i.id === id)
    if (index !== -1) {
      this.items[index] = { ...this.items[index], ...updates }
      this.notify()
    }
  }

  // Remove item (e.g. user clicks 'X')
  removeItem(id: string) {
    this.items = this.items.filter(i => i.id !== id)
    this.notify()
  }

  getItems() {
    return this.items
  }

  // Simple subscription pattern
  subscribe(listener: (items: UploadItem[]) => void) {
    this.listeners.push(listener)
    listener(this.items) // Immediate callback
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener)
    }
  }

  private notify() {
    this.listeners.forEach(l => l(this.items))
  }
}

export const uploadStore = new UploadStore()